import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const SendIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4 20.32V13.9878L17.1034 12.16L4 10.3322V4L22.3448 12.16L4 20.32Z'
                fill='currentColor'
            />
        </>
    ),
})

SendIcon.displayName = 'SendIcon'
